<div class="editor-footer-wrapper">
  <div class="editor-footer-wrapper-top">
    <div class="left-controls">
      <div v-if="config?.aiEnabled" class="ai-toggle-wrapper">
        <div class="ai-toggle-icon">
          <SmartStars :enableAnimation="true" />
        </div>
        <MdTypography variant="micro1--medium" color="spirits--900" responsive="true" class="ai-writing-text">
          {{ $t('pages.aiTextEditor.ai_writing') }}
        </MdTypography>
        <ToggleSwitch :model-value="isAiEnabled" :switch-on-color="aiToggleOnColor" :switch-off-color="aiToggleOffColor"
          input-id="ai-toggle-switch" size="medium" @change="aIToggle" v-tooltip="{
            content: $t('pages.aiTextEditor.ai_editor_tooltip_enabled_once'),
            html: true,
            placement: 'top', 
            distance: config?.aiFooter?.tooltipDistance,
            triggers: isAiEnabled ? [] : ['hover', 'focus', 'click']
            }" />
      </div>
    </div>

    <div class="right-controls">
      <div v-if="isAiEnabled" class="diff-actions">
        <MdButton :disabled="isButtonsDisabled" class="diff-action-btn" color="lightgrey" size="small" type="button"
          tabidx="2" @click="$emit('discard')">
          {{ $t('pages.aiTextEditor.discard') }}
        </MdButton>

        <MdButton :disabled="isButtonsDisabled" class="diff-action-btn" textalign="center" color="blue" size="small"
          tabidx="2" @click="$emit('replace')">
          {{ $t('pages.aiTextEditor.accept') }}
        </MdButton>
      </div>
    </div>
  </div>

  <div class="editor-footer-wrapper-bottom" v-if="shouldShowAiActions">
    <div class="ai-actions">
      <MdButton class="ai-action-btn" size="small" :disabled="isAiActionDisabled" color="white"
        v-if="config?.aiActions.boostVisibility" @click="$emit('ai-action','boostVisibility')">
        <span slot="icon-start" class="icon">
          <SmartStars v-if="!actionSuccessStates.boostVisibility" />
          <MdIconPieSuccess v-if="actionSuccessStates.boostVisibility" />
        </span>
        {{ $t('pages.aiTextEditor.boostVisibility') }}
      </MdButton>
      <MdButton class="ai-action-btn" size="small" :disabled="isAiActionDisabled" color="white"
        v-if="config?.aiActions.polishWriting" @click="$emit('ai-action','polishWriting')">
        <span slot="icon-start" class="icon">
          <SmartStars v-if="!actionSuccessStates.polishWriting" />
          <MdIconPieSuccess v-if="actionSuccessStates.polishWriting" />
        </span>
        {{ $t('pages.aiTextEditor.polishWriting') }}
      </MdButton>
      <MdButton class="ai-action-btn" size="small" :disabled="isAiActionDisabled" color="white"
        v-if="config?.aiActions.fixGrammar" @click="$emit('ai-action','fixGrammar')">
        <span slot="icon-start" class="icon">
          <SmartStars v-if="!actionSuccessStates.fixGrammar" />
          <MdIconPieSuccess v-if="actionSuccessStates.fixGrammar" />
        </span>
        {{ $t('pages.aiTextEditor.fixGrammar') }}
      </MdButton>
      <MdButton class="ai-action-btn" size="small" :disabled="isAiActionDisabled || isShortenTextDisabled" color="white"
        v-if="config?.aiActions.shortenText" @click="$emit('ai-action','shortenIt')"
        v-tooltip="{content: $t('pages.aiTextEditor.ai_editor_tooltip_shorten_text'), placement: 'top', triggers: !isShortenTextDisabled ? [] : ['hover', 'focus', 'click']}">
        <span slot="icon-start" class="icon">
          <SmartStars v-if="!actionSuccessStates.shortenIt" />
          <MdIconPieSuccess v-if="actionSuccessStates.shortenIt" />
        </span>
        {{ $t('pages.aiTextEditor.shortenText') }}
      </MdButton>
      <MdButton variant="ghost" size="small" color="darkgrey" @click="showInfoModal=true">
        <MdIconFailed rotate="down" />
      </MdButton>
    </div>
  </div>

  <MdTypography v-if="shouldShowAiResponseError" data-qa-id="errors-list-forcedErrors-details" tag="p"
    variant="body2--regular" color="red-babe--500" responsive="true">
    {{ aiResponseError.errorMessage }}
  </MdTypography>

  <MdTypography variant="body2--regular" color="spirits--700" responsive="true">
    {{ $t('pages.aiTextEditor.disclaimer') }}
  </MdTypography>

  <AiConsentModal v-if="showInfoModal" :show="showInfoModal" @cancel="showInfoModal=false" />
</div>